import { useRef } from 'react';
import { Navigate } from 'react-router-dom';
import SidebarMenu from '../components/sidebar/sidebar-menu';
import { Outlet } from 'react-router-dom';
import { useUsuario } from '../context/usuarioContext';
import { Toast } from 'primereact/toast';

export default function DashboardLayout() {
  const { usuario } = useUsuario();
  const toast = useRef(null);

  if (!usuario) return <Navigate to="/auth" replace />;

  return (
    <div className="dashboar-layout">
      <Toast ref={toast} position="center"/>
      <SidebarMenu />
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}